/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * One entry per tracked document mutation. Like the appointment StatusHistory, each entry snapshots the tracked fields at write time, so comparing consecutive entries shows what changed from -> to.
 * @export
 * @interface DocumentStatusHistory
 */
export interface DocumentStatusHistory {
    /**
     * 
     * @type {string}
     * @memberof DocumentStatusHistory
     */
    action?: DocumentStatusHistoryActionEnum;
    /**
     * 
     * @type {number}
     * @memberof DocumentStatusHistory
     */
    date?: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentStatusHistory
     */
    by_role?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentStatusHistory
     */
    by_id?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentStatusHistory
     */
    patient_id?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentStatusHistory
     */
    physician_id?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentStatusHistory
     */
    document_type?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentStatusHistory
     */
    title?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentStatusHistory
     */
    approved?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentStatusHistory
     */
    hide?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentStatusHistory
     */
    archived?: boolean;
}


/**
 * @export
 */
export const DocumentStatusHistoryActionEnum = {
    Created: 'created',
    Approved: 'approved',
    Unapproved: 'unapproved',
    PatientChanged: 'patient_changed',
    PhysicianChanged: 'physician_changed',
    DetailsChanged: 'details_changed',
    Hidden: 'hidden',
    Unhidden: 'unhidden',
    Archived: 'archived',
    Unarchived: 'unarchived',
    Read: 'read',
    Filled: 'filled'
} as const;
export type DocumentStatusHistoryActionEnum = typeof DocumentStatusHistoryActionEnum[keyof typeof DocumentStatusHistoryActionEnum];


/**
 * Check if a given object implements the DocumentStatusHistory interface.
 */
export function instanceOfDocumentStatusHistory(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DocumentStatusHistoryFromJSON(json: any): DocumentStatusHistory {
    return DocumentStatusHistoryFromJSONTyped(json, false);
}

export function DocumentStatusHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentStatusHistory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'action': !exists(json, 'action') ? undefined : json['action'],
        'date': !exists(json, 'date') ? undefined : json['date'],
        'by_role': !exists(json, 'by_role') ? undefined : json['by_role'],
        'by_id': !exists(json, 'by_id') ? undefined : json['by_id'],
        'patient_id': !exists(json, 'patient_id') ? undefined : json['patient_id'],
        'physician_id': !exists(json, 'physician_id') ? undefined : json['physician_id'],
        'document_type': !exists(json, 'document_type') ? undefined : json['document_type'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'approved': !exists(json, 'approved') ? undefined : json['approved'],
        'hide': !exists(json, 'hide') ? undefined : json['hide'],
        'archived': !exists(json, 'archived') ? undefined : json['archived'],
    };
}

export function DocumentStatusHistoryToJSON(value?: DocumentStatusHistory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'action': value.action,
        'date': value.date,
        'by_role': value.by_role,
        'by_id': value.by_id,
        'patient_id': value.patient_id,
        'physician_id': value.physician_id,
        'document_type': value.document_type,
        'title': value.title,
        'approved': value.approved,
        'hide': value.hide,
        'archived': value.archived,
    };
}

